import { Component, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as EventEmitter from 'events';

@Component({
  selector: 'app-admin-info',
  templateUrl: './admin-info.component.html',
  styleUrls: ['./admin-info.component.css']
})
export class AdminInfoComponent implements OnInit {


  adminCode="";

  constructor() { }

  ngOnInit(): void {
  }

  saveCode(){
    var changeCode = <HTMLInputElement>document.getElementById('change-code');
    this.adminCode = changeCode.value;

  }
}
